module.exports = __webpack_public_path__ + "img/icon-boar.20cadb86.svg";